<template>
  <div class="ad">
    <el-carousel v-if="content.length >= 1" :autoplay="false" height="100px">
      <el-carousel-item v-for="item in content" :key="item.id">
        <el-link :href="item.url">
          <el-image style="width: 100%;" :src="item.image_link" fit="scale-down"></el-image>
        </el-link>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
import api from "../api/api"

export default ({
  name: "Ad",
  data() {
    return {
      fit: 'cover',
      content: []
    }
  },
  async mounted() {
    let json = await api.ad.index({'position':'index'})
    this.content = json.data.ad;
  }
})
</script>

<style scoped>
.ad {

}
/deep/ .el-carousel__indicators {
  left: unset;
  right: -20px;
}
</style>